import paymentMethodFormat from '@/utils/paymentMethodFormat';
import formatPromoCodeReport from '@/utils/formatPromoCodeReport';

export default function normalize(data) {
    const feesConstants = {
        ORDER_PROCESSING: 'ORDER_PROCESSING',
        TM_PROCESSING: 'TM_PROCESSING',
        INSURANCE_BONDING: 'INSURANCE_BONDING',
        BREAKAGE_BONDING: 'BREAKAGE_BONDING',
        GST_PROCESSING: 'GST_PROCESSING',
    };

    const taxesConstants = {
        INCLUDED: 'INCLUDED',
        EXCLUDED: 'EXCLUDED',
        CITY: 'CITY',
        COUNTY: 'COUNTY',
        STATE: 'STATE',
    };

    const commissionConstants = {
        PROMOTER: 'PROMOTER',
        DATA_PROVIDER: 'DATA_PROVIDER',
        CLIENT: 'CLIENT',
        GST: 'GST',
    };

    function feeTypeAmount(fees, feeType) {
        let result = fees.find((fee) => fee.type === feeType);

        return result?.amount || 0;
    }

    function taxTypeAmount(taxes, taxType) {
        let result = taxes.find((tax) => tax.type === taxType);

        return result?.amount || 0;
    }

    function commissionTypeAmount(commissions, commissionType) {
        let result = commissions.find((commission) => commission.partnerType === commissionType);
        return result ? result.amount : undefined;
    }

    const hotel = data.hotel || {};
    const {
        hotelBookingNumber,
        hotelName,
        address,
        latitude,
        longitude,
        roomType,
        supplier,
        cancellationPolicies,
        stayRange,
        roomCount,
    } = hotel;

    const hotelData = {
        hotelBookingNumber: hotelBookingNumber || data.hotelBookingNumber || '',
        hotelName: hotelName || '',
        hotelState: address?.stateCode || null,
        hotelCity: address?.cityName || null,
        hotelCountry: address?.countryCode || null,
        hotelLatitude: latitude || null,
        hotelLongitude: longitude || null,
        roomType: roomType || '',
        bookingStatus: data.status || '',
        hotelSupplier: supplier || '',
        cancellationPolicies: cancellationPolicies || [],
        checkIn: stayRange?.checkin || '',
        checkOut: stayRange?.checkout || '',
        lengthOfStay: stayRange?.lengthOfStay || null,
        roomCount: roomCount || 0,
    };

    return {
        orderNumber: data.orderNumber,
        id: data.id,
        hotelBookingNumber: data.hotelBookingNumber,
        upsellOrderNumber: data.upsellOrderNumber,
        createdLocalDateTime: data.createdLocalDateTime,
        createdDateTime: data.createdDateTime,
        currency: data.currency,
        eventSystem: data.event?.host || null,
        eventCode: data.event?.code || null,
        eventPartnerProductId: data.event?.partnerProductId || null,
        legacyEventId: data.event?.legacyEventId || null,
        eventName: data.event.name,
        eventDate: data.event.startDate,
        ticketType: data.event.ticketType,
        venueName: data.event.venueName,
        venueState: data.event.venueState,
        venueCity: data.event.venueCity,
        venueZipCode: data.event.venueZipCode,
        channel: data.channel || '',
        deviceType: data.deviceType || '',
        processor: data.paymentDetails?.processor || '',
        invoiceId: data.paymentDetails?.invoiceId || '',
        paymentMethod: paymentMethodFormat(data.paymentDetails?.paymentMethod),
        grossTotalValue: data.amounts.grossTotalValue,
        eventTicketsNumber: data.event.ticketsNumber,
        ticketCost: data.amounts.ticketCost,
        fees: data.amounts.ticketFees,
        subTotal: data.amounts.ticketSubTotal,
        ticketTaxes: data.amounts.ticketTaxes,
        totalTicketCost: data.amounts.totalTicketCost,
        hotelSellingPrice: data.amounts.totalSettlement,
        packageTax: data.amounts.estimatedResellerTax,
        localTaxesAndFees: data.amounts.localTaxesAndFees,
        totalHotelCost: data.amounts.totalHotelCost,
        hotelCostLocal: data.amounts.hotelCostLocal,
        hotelMargin: data.amounts.netRevenue,
        gstRevSplit: '',
        clientRevSplit: '',
        tmRevSplit: '',
        promoCodeAmount: data.amounts.promoCodeDiscount,
        promoCode: formatPromoCodeReport(data.promoCode, data.currency),
        tmProcessing: feeTypeAmount(data.fees, feesConstants.TM_PROCESSING),
        insuranceBonding: feeTypeAmount(data.fees, feesConstants.INSURANCE_BONDING),
        breakageBonding: feeTypeAmount(data.fees, feesConstants.BREAKAGE_BONDING),
        gstProcessing: feeTypeAmount(data.fees, feesConstants.GST_PROCESSING),
        promoterCommission: commissionTypeAmount(data.commissions, commissionConstants.PROMOTER),
        tmCommission: commissionTypeAmount(data.commissions, commissionConstants.CLIENT),
        tmPreSplitCommission: commissionTypeAmount(
            data.commissions,
            commissionConstants.DATA_PROVIDER
        ),
        gstCommission: commissionTypeAmount(data.commissions, commissionConstants.GST),
        supplierIncludedTax: taxTypeAmount(data.taxes, taxesConstants.INCLUDED),
        supplierExcludedTax: taxTypeAmount(data.taxes, taxesConstants.EXCLUDED),
        packageStateTax: taxTypeAmount(data.taxes, taxesConstants.STATE),
        packageCityTax: taxTypeAmount(data.taxes, taxesConstants.CITY),
        packageCountyTax: taxTypeAmount(data.taxes, taxesConstants.COUNTY),
        ...hotelData,
    };
}
